import { ActionPlanAction } from "src/api/client-api/ActionPlan/ActionPlanAction";
import { PostElement } from "src/api/client-api/post/postSchema";

type Opts = {
    actionPlanAction: ActionPlanAction | undefined;
    elements: PostElement[] | undefined;
};
export const computeAreQuestionsAnswered = (options: Opts): boolean => {
    const { actionPlanAction, elements } = options;
    const properties = actionPlanAction?.action.ssqProperties;

    if (properties === undefined) {
        // Nothing to check, yes ?
        return true;
    }

    if (elements === undefined) {
        // Nothing to check, yes ?
        return true;
    }

    const areQuestionsAnswered = properties.every((ssqProperty) => {
        const element = elements.find((element) => element.ssqPropertyId === ssqProperty.id);

        if (element === undefined) return false;

        return element.value !== "";
    });

    return areQuestionsAnswered;
};
